<ng-container [ngSwitch]="type">
  <div class="list-batch batch" *ngSwitchCase="ConfigTransferEnum.Automatic">
    <form [formGroup]="form">
      <div class="batch-automatic automatic">
        <span class="automatic-text flex-3">{{ batchConfig?.Bank }}</span>
        <span class="automatic-text flex-3">{{ batchConfig?.Channel }}</span>
        <div class="flex-1 d-flex justify-flex-end">
          <button
            type="button"
            class="automatic-btn"
            (click)="deleteBatchConfig()"
          >
            Excluir
          </button>
        </div>
      </div>
    </form>
  </div>

  <div class="list-batch" *ngSwitchCase="ConfigTransferEnum.Manual">
    <form [formGroup]="form">
      <div class="batch-manual manual direction-column">
        <div class="vw-100 d-flex align-center justify-space-between pt-3">
          <span class="manual-text d-flex flex-1 justify-center plr-5">{{
            batchConfig.Bank
          }}</span>
          <span class="manual-text d-flex flex-1 justify-center plr-5">{{
            batchConfig.Channel
          }}</span>
          <ng-container formArrayName="Parameters">
            <ng-container
              *ngFor="
                let parameterGroup of batchConfigParametersformGroup.controls;
                let indexParameter = index
              "
              [formGroupName]="indexParameter"
            >
              <div class="d-flex flex-1 justify-center plr-5">
                <app-c-select-multi
                  [multi]="true"
                  [optionsList]="contractOpts"
                  placeholder="Selecione"
                  formControlName="ContractStatus"
                ></app-c-select-multi>
              </div>
              <div class="d-flex flex-1 justify-center plr-5">
                <app-c-select-multi
                  [multi]="true"
                  [optionsList]="invoiceOpts"
                  placeholder="Selecione"
                  formControlName="BatchStatus"
                ></app-c-select-multi>
              </div>
              <div class="d-flex flex-1 justify-center plr-5">
                <app-c-select-multi
                  [optionsList]="paymentOpts"
                  placeholder="Selecione"
                  formControlName="PaymentStatus"
                ></app-c-select-multi>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div
          class="manual-actions actions vw-100 d-flex justify-flex-end align-center pt-7"
        >
          <button
            type="button"
            class="actions-save"
            (click)="saveManualConfig()"
          >
            Salvar
          </button>
          <button
            type="button"
            class="actions-delete"
            (click)="deleteBatchConfig()"
          >
            Excluir
          </button>
        </div>
      </div>
    </form>
  </div>
</ng-container>
